import { defineRouting } from 'next-intl/routing';
import { SUPPORTED_LOCALES } from 'lib/constants.mjs';

export const routing = defineRouting({
	localePrefix: 'as-needed',
	locales: SUPPORTED_LOCALES,
	defaultLocale: 'en',
	localeCookie: true,
	localeDetection: true,
});
